import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import UploadInput from '../../../../library/inputs/upload/UploadInput';

interface Props {
  id: string;
  enabled: boolean;
  value: string | File;
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  readOnlyMode?: boolean;
}

const UploadFileField: FC<Props> = ({ id, enabled, value, setFieldValue, setFieldTouched, readOnlyMode }: Props) => {
  return (
    <UploadInput
      id={id}
      disabled={!enabled}
      value={value}
      readOnlyMode={readOnlyMode}
      onChange={async (file) => {
        await setFieldValue(id, file, true);
        await setFieldTouched(id, true, true);
      }}
    />
  );
};

export default UploadFileField;
